/**
 * Dispara o download de um Blob no browser. Padrão único do app — extrai a
 * implementação que estava inline em `api/cte.ts` / `api/cotacao.ts`: cria um
 * `<a download>`, clica e revoga a object URL.
 */
export function baixarBlob(nomeArquivo: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
